<template>
  <div class="tags-editor h-100">
    <v-card class="tags__card pa-0 h-100">
      <v-card-title class="headline">Edit Tags</v-card-title>

      <!-- Search -->
      <div class="pb-3">
        <div class="px-4 pb-1">
          <span class="subtitle-2 pl-1"> Search </span>
        </div>
        <v-text-field
          ref="searchInput"
          v-model="search"
          label="Filter tags"
          class="tags__search-field px-4"
          hide-details
          dense
          solo
          flat
          outlined
        />
      </div>

      <!-- Add new tag -->

      <div class="pb-1">
        <div class="px-4 pb-1">
          <span class="subtitle-2 pl-1"> Add a new tag </span>
        </div>
        <div class="d-flex align-center mb-4 px-4">
          <v-text-field
            v-model="newTag.name"
            label="Tag name"
            dense
            outlined
            hide-details
            class="flex-grow-1 mr-2"
          />
          <v-text-field
            v-model="newTag.description"
            label="Tag description"
            dense
            outlined
            hide-details
            class="flex-grow-2 mr-2"
          />
          <v-btn
            color="primary"
            :disabled="!newTag.name.trim()"
            @click="createTag"
          >
            Add
          </v-btn>
        </div>
      </div>

      <v-list dense class="tags__list overflow-y-auto overflow-x-hidden pa-0">
        <template v-if="filteredTags.length > 0">
          <v-list-item
            v-for="tag in filteredTags"
            :key="tag.id"
            class="tags__list-item d-flex align-center justify-between w-100 px-0"
          >
            <div class="w-100">
              <!-- Name -->
              <SummaryElement
                :value="{
                  type: 'TEXT_FIELD',
                  value: tag.name,
                  key: 'name',
                }"
                class="px-4 pt-2"
                reset-on-blur
                :has-default-save-callback="false"
                @save="updateTagField(tag, 'name', $event)"
              >
                <template #value-text>
                  <TagChip :tag="tag" />
                </template>
              </SummaryElement>

              <!-- Description -->
              <SummaryElement
                :value="{
                  type: 'TEXT_AREA',
                  value: tag.description || '',
                  key: 'description',
                }"
                class="px-4 pb-2"
                reset-on-blur
                :has-default-save-callback="false"
                @save="updateTagField(tag, 'description', $event)"
              />
            </div>

            <v-btn
              icon
              color="error"
              class="tag-delete-btn mr-2"
              @click="deleteTag(tag)"
            >
              <v-icon small>fa-trash</v-icon>
            </v-btn>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import TagChip from "@/components/tags/TagChip.vue"
import SummaryElement from "@/components/cameraTabs/summary/SummaryElement.vue"
import { useTagStore } from "@/stores/tag"
import { mapStores } from "pinia"

export default {
  name: "TagEditor",
  components: {
    SummaryElement,
    TagChip,
  },
  data() {
    return {
      search: "",
      newTag: {
        name: "",
        description: "",
      },
    }
  },
  computed: {
    ...mapStores(useTagStore),
    filteredTags() {
      return this.tagStore.tags.filter((t) =>
        this.tagStore.matchTag(t, this.search)
      )
    },
  },
  methods: {
    async createTag() {
      const name = this.newTag.name.trim()
      const description = this.newTag.description.trim()

      await this.tagStore.createTag({ name, description })

      this.newTag = {
        name: "",
        description: "",
      }
    },
    async updateTagField(tag, field, value) {
      if (tag[field] === value) {
        return
      }
      const updatedTag = { ...tag, [field]: value }
      await this.tagStore.updateTag(updatedTag)
    },
    async deleteTag(tag) {
      if (!confirm(`Delete tag "${tag.name}"?`)) {
        return
      }
      await this.tagStore.deleteTag(tag)
    },
  },
}
</script>

<style lang="scss">
.tags-editor {
  .tags__card {
    width: auto;
  }
  .tags__list {
    max-height: none;
    height: calc(100% - 225px);
  }
  .tags__list-item {
    border-bottom: 1px solid var(--dash-border-color);
    .tag-delete-btn {
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }
    &:hover {
      background: #e2f2fcaa;
      .tag-delete-btn {
        opacity: 1;
      }
    }
  }
  .summary-element {
    &__default-content > * {
      white-space: wrap !important;
    }
    &--highlighted {
      background-color: transparent;
    }
    &__action-btn {
      display: none;
    }
  }
  .tag.v-chip.v-size--x-small {
    border-radius: 14px;
    height: 18px;
    padding: 0 10px;
    .tag__text {
      font-size: 12px;
    }
  }
}
</style>
